import React, {Component} from 'react';
import {UncontrolledTooltip} from 'reactstrap';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import moment from 'moment';
import 'moment/locale/tr';
import {deepCopyObject} from "../../../helper/helper";
import {validateField} from "../../../common/validation";

class CarrierParty extends Component{
	constructor(props){
		super(props);
		this.state ={error:{},carrierParty:null};
		this.onChange 		= this.onChange.bind(this);
		this.validateField  = this.validateField.bind(this);
	}

	componentWillMount() {
		this.setState({carrierParty:this.props.carrierParty});
	}

	onChange(e){
		let carrierParty = deepCopyObject(this.state.carrierParty);
		carrierParty[e.target.name]= e.target.value;
		if(e.target.name === "carrierPartyId" && (e.target.value).length !== 11){
			carrierParty["carrierPartyFirstName"] = null;
			carrierParty["carrierPartyFamilyName"] = null;
		}
		this.setState({carrierParty});
		this.props.listener(carrierParty);
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
		this.props.errorListener(error);
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	componentWillReceiveProps(nextProps){
		if(this.props.error !== nextProps.error){
			this.setState({error:nextProps.error});
		}

		if (nextProps.manual) {
			this.setState({carrierParty: nextProps.carrierParty,error:{}});
			this.props.isManual(false);
			this.props.errorListener({});
		}
	}

	render(){
		if(!this.state.carrierParty)
			return <div>Yükleniyor...</div>;

		let actualDeliveryDate 		= this.state.carrierParty.actualDeliveryDate || '';
		let carrierPartyId 	 		= this.state.carrierParty.carrierPartyId || '';
		let carrierPartyName 	 	= this.state.carrierParty.carrierPartyName || '';
		let carrierPartyFirstName 	= this.state.carrierParty.carrierPartyFirstName || '';
		let carrierPartyFamilyName  = this.state.carrierParty.carrierPartyFamilyName || '';

		return (
			<div>
                <div className="row">
                    <div className="col-sm-12 row">
                        <div className="col-sm-6 row">
                            <label className="col-md-4 col-form-label">Gönderim Tarihi *</label>
                            <div className="col-md-8">
                                <div className={"form-group" + this.validateClass("actualDeliveryDate")}>
                                    <Datetime locale="tr"
                                          className="datepicker"
                                          input={true}
                                          inputProps={{id:"actualDeliveryDate"}}
                                          onBlur={(momentObj)=>this.validateField({target:{id:"actualDeliveryDate",dataset:{'vdata':"date",'vlength':"1,255"},value:(!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)}})}
                                          closeOnSelect={true}
                                          value={moment(actualDeliveryDate,"YYYY-MM-DD",true).isValid() ? moment(actualDeliveryDate).format("DD-MM-YYYY"):actualDeliveryDate}
                                          dateFormat="DD-MM-YYYY"
                                          timeFormat={false}
                                          isValidDate={function (current) {return current.isBefore(Datetime.moment());}}
                                          onChange={(momentObj) => this.onChange({target:{name:'actualDeliveryDate',value:(!(typeof momentObj === "string") ? momentObj.format("YYYY-MM-DD") : momentObj)}})}/>
                                    {this.validateMessage("actualDeliveryDate") !== "" &&
                                        <UncontrolledTooltip placement="right" target={"actualDeliveryDate"} delay={0}>
                                            {this.validateMessage("actualDeliveryDate")}
                                        </UncontrolledTooltip>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-6 row">
                            <label className="col-md-4 col-form-label">VKN/TCKN *</label>
                            <div className="col-md-8">
                                <div className={"form-group" + this.validateClass("carrierPartyId")}>
                                    <input className="form-control"
                                           type="text"
                                           data-vdata="identifier"
                                           data-vlength="10,11"
                                           maxLength="11"
                                           id="carrierPartyId"
                                           name="carrierPartyId"
                                           onBlur={this.validateField}
                                           onChange={this.onChange}
                                           value={carrierPartyId}/>
                                    {this.validateMessage("carrierPartyId") !== "" &&
                                    <UncontrolledTooltip placement="right" target={"carrierPartyId"} delay={0}>
                                        {this.validateMessage("carrierPartyId")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-6 row">
                            <label className="col-md-4 col-form-label">Unvan {(carrierPartyId && carrierPartyId.length === 10) ? "*":  ""}</label>
                            <div className="col-md-8">
                                <div className={"form-group" + this.validateClass("carrierPartyName")}>
                                    <input className="form-control"
                                           type="text"
                                           data-vlength={carrierPartyId ? (carrierPartyId.length === 10 ? "1,255":  "0,255") : "0,255" }
                                           id="carrierPartyName"
                                           name="carrierPartyName"
                                           onBlur={this.validateField}
                                           onChange={this.onChange}
                                           value={carrierPartyName}/>
                                    {this.validateMessage("carrierPartyName") !== "" &&
                                    <UncontrolledTooltip placement="right" target={"carrierPartyName"} delay={0}>
                                        {this.validateMessage("carrierPartyName")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>

                        {(carrierPartyId && carrierPartyId.length === 11) &&
                            <div className="col-sm-6 row">
                                <label className="col-md-4 col-form-label">Ad *</label>
                                <div className="col-md-8">
                                    <div className={"form-group" + this.validateClass("carrierPartyFirstName")}>
                                        <input className="form-control"
                                               type="text"
                                               data-vlength={carrierPartyId ? (carrierPartyId.length === 11 ? "1,255":  "0,255") : "0,255" }
                                               id="carrierPartyFirstName"
                                               name="carrierPartyFirstName"
                                               onBlur={this.validateField}
                                               onChange={this.onChange}
                                               value={carrierPartyFirstName}/>
                                        {this.validateMessage("carrierPartyFirstName") !== "" &&
                                        <UncontrolledTooltip placement="right" target={"carrierPartyFirstName"} delay={0}>
                                            {this.validateMessage("carrierPartyFirstName")}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                        }
                        {(carrierPartyId && carrierPartyId.length === 11) &&
                            <div className="col-sm-6 row">
                                <label className="col-md-4 col-form-label">Soyadı *</label>
                                <div className="col-md-8">
                                    <div className={"form-group" + this.validateClass("carrierPartyFamilyName")}>
                                        <input className="form-control"
                                               type="text"
                                               data-vlength={carrierPartyId ? (carrierPartyId.length === 11 ? "1,255":  "0,255") : "0,255" }
                                               id="carrierPartyFamilyName"
                                               name="carrierPartyFamilyName"
                                               onBlur={this.validateField}
                                               onChange={this.onChange}
                                               value={carrierPartyFamilyName}/>
                                        {this.validateMessage("carrierPartyFamilyName") !== "" &&
                                        <UncontrolledTooltip placement="right" target={"carrierPartyFamilyName"} delay={0}>
                                            {this.validateMessage("carrierPartyFamilyName")}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
			</div>
		);
	}
}

export default CarrierParty;